<template>
  <div>
    <div class="uk-section-default">
      <nav
          class="mbk_border_bottom_primary_5px uk-navbar-container uk-box-shadow-medium uk-padding-small uk-padding-remove-horizontal"
          style="position: relative; z-index: 985;">
        <div class="uk-container uk-flex uk-flex-between uk-flex-middle">
          <img :src="logoUrl"
               id="edoc_logo" alt="mbulak">
          <span>
                            <button v-if="showClientDocListButton" @click="goToClientDocListPage"
                                    class="uk-button uk-button-primary uk-button-small" style="margin-right: 1rem;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 24 24"
                                     fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round"
                                     stroke-linejoin="round" class="feather feather-paperclip"><path
                                    d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path></svg>
                                <span class="uk-visible@s uk-margin-small-left">{{ $t("my_docs") }}</span>
                            </button>
                            <select v-model="currentLocal" class="uk-select uk-form-small" style="width: 100px">
                                <option v-for="l in lang" :value="l.CODE" :key="l.CODE">{{ l.NAME }}</option>
                            </select>
                        </span>
        </div>
      </nav>
    </div>
    <div class="uk-container">
      <div id="mbk_working_area">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {LANG} from "@/i18n/main";

export default {
  name: "app",
  data() {
    return {
      lang: LANG
    };
  },
  methods: {
    ...mapActions(["set_locale"]),
    goToClientDocListPage() {
      if (!this.showClientDocListButton) return;
      this.$router.push({
        name: "clientDocList",
        params: {docsetID: this.user.docsetID}
      });
    },
  },
  computed: {
    ...mapGetters(["locale", "user", "showDocuments"]),
    currentLocal: {
      get() {
        return this.locale;
      },
      set(val) {
        this.set_locale(val);
        this.$i18n.locale = val;
      }
    },
    showClientDocListButton() {
      return (
          this.$route.name !== "clientDocList" &&
          this.$route.name !== "checkPinCode" &&
          this.user.hasCredentials &&
          this.showDocuments
      );
    },
    logoUrl() {
      return process.env.NODE_ENV === "production" ? "/static/images/mbulak_logo_fullcolor.png" : "/images/mbulak_logo_fullcolor.png";
    }
  }
};
</script>
<style>
html, body {
  height: 100%;
  min-height: 100%;
}

#edoc_logo {
  height: 4em;
}

svg.feather {
  max-width: initial;
}

@media only screen and (max-width: 600px) {
  #edoc_logo {
    height: 4em;
  }
}
</style>
